export enum QuestionIndex {
    One = 'One',
    Two = 'Two',
    Three = 'Three',
}
